import { useState } from "react";
import { useNavigate } from "react-router-dom";

// MUI
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// API
import BASE_URL from "api/Api";

function Permissions() {
  const [permissionCode, setPermissionCode] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${BASE_URL}super_admin/add_permissions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ permission_code: permissionCode }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to create permission");
      }

      alert("Permission created successfully");
      navigate("/list");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={12} pb={4}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8} lg={6}>
            <Card>
              {/* HEADER */}
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                mx={2}
                mt={-3}
                p={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Create Permission
                </MDTypography>

                <MDButton
                  variant="contained"
                  color="white"
                  size="small"
                  onClick={() => navigate("/list")}
                >
                  View Permissions
                </MDButton>
              </MDBox>

              {/* BODY */}
              <MDBox p={4}>
                <MDBox component="form" onSubmit={handleSubmit}>
                  <MDInput
                    label="Permission Code"
                    fullWidth
                    value={permissionCode}
                    onChange={(e) => setPermissionCode(e.target.value)}
                  />

                  <MDBox mt={4}>
                    <MDButton
                      type="submit"
                      variant="gradient"
                      color="info"
                      fullWidth
                      size="large"
                    >
                      Save Permission
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}

export default Permissions;
